export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
